import ActivityProfilesList from "PFApp/activities/show/parts/activity_profiles/activity_profiles_list";
import { Modal } from "PFComponents/modal";
import { ActivityProfileType } from "PFTypes";
import { useTranslation } from "react-i18next";

import { useCurrentActivity } from "../hooks/use_current_activity";
import { useIsUnbiasedEnabled } from "../hooks/use_is_unbiased_enabled";
import { useOwnerRemove } from "./hooks/use_owner_remove";

type RemoveOwnersProps = { onClose: VoidFunction };

const RemoveOwners = ({ onClose }: RemoveOwnersProps) => {
  const { t } = useTranslation(["activities", "translation"]);

  const activity = useCurrentActivity();

  const isUnbiasedEnabled = useIsUnbiasedEnabled(activity);

  const { handleRemove, getRemoveModalContent } = useOwnerRemove(activity);

  return (
    <Modal
      title={t("activities:show.parts.removeOwners")}
      onClose={onClose}
      labelCancel={t("translation:close")}
      showOKButton={false}
    >
      <ActivityProfilesList
        isUnbiasedEnabled={isUnbiasedEnabled}
        activityProfiles={activity.owners}
        title={t("activities:show.parts.sharedWith")}
        onRemove={activity.owners.length > 1 ? handleRemove : null}
        getRemoveModalContent={getRemoveModalContent}
        activityProfileType={ActivityProfileType.Owner}
      />
    </Modal>
  );
};

export default RemoveOwners;
